import styled from 'styled-components';

export const Container = styled.div`
  background-color: red;
  position: absolute;
  bottom: 0;
  height: 33px;
  left: 0;
  right: 0;
  justify-content: center;
`;

export const ErrorText = styled.p`
  color: white;
  text-align: center;
  margin: 7px 0 0 0;
  font-weight: bold;
`;

export const CloseButton = styled.a`
  position: absolute;
  cursor: pointer;
  right: 15px;
  top: 0;
  bottom: 0;
`;
